import React from 'react';
import styled from 'styled-components/macro';
import get from 'lodash/get';

import ImageBackground from 'components/ImageBackground';


const ImageSlide = ({ children, caption, image, imageSize, imageFit = 'contain', bgColor, ...props }) => {
    const srcPath = imageSize ? [ 'sizes', imageSize ] : 'url';
    const imageSrc = get(image, srcPath, undefined);
    
    return (
        <Container {...props}>
            <Inner>
                <ImageBackground src={imageSrc} imageFit={imageFit} bgColor={bgColor} />
                
                {caption && (
                    <Caption>
                        {caption}
                    </Caption>
                )}
                
                {imageSrc && <ImageForLoading src={imageSrc}/>}
            </Inner>
        </Container>
    );
};

const Slide = ({ children, bgColor, ...props }) => {
    return (
        <Container {...props} bgColor={bgColor}>
            <Inner>
                {children}
            </Inner>
        </Container>
    );
};

export default Slide;
export { ImageSlide };


const Container = styled.div`
	width: 100%;
	height: 100%;
    background-color: ${props => props.bgColor || props.theme.app_background};
`;

const Inner = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
`;

const Caption = styled.div`
    position: absolute;
    bottom: 0;
    left: 50%;
    z-index: 2;
    transform: translateX(-50%);
    font-family: ${props => props.theme.heading_font};
    font-size: 1.8rem;
    color: white;
    background-color: ${props => props.theme.accent_color};
    padding: .6rem 1.8rem;
`;

const ImageForLoading = styled.img`
    position: absolute;
    top: 0;
    left: 0;
    width: 0;
    height: 0;
`;
